module.exports = __webpack_public_path__ + "static/media/BNB.ce0906f0.svg";